<template>
  <el-container v-loading="loading" element-loading-text="Ładowanie projektów...">
    <el-main class="main">
      <img src="/img/logo.png" alt="Kreator" height="200" />
      <p>W Twoim zamówieniu znajdują się następujące projekty. Wybierz projekt który chcesz edytować:</p>
        <el-row class="templates" justify="center" type="flex">
          <el-col
            :xs="24"
            :sm="12"
            :md="8"
            :lg="4"
            v-for="(template, index) in templates"
            :key="index"
          >
            <TemplateTile :template="template" :urlSuffix="suffix" />
          </el-col>
        </el-row>
    </el-main>
  </el-container>
</template>

<script>
  import { mapActions } from 'vuex'
  import TemplateTile from '../components/Home/TemplateTile.vue';
  
  export default {
    name: 'Projects',
    data() {
      return {
        code: '',
        loading: true,
        error: false,
        templates: []
      }
    },
    computed: {
      suffix() {
        return `/${this.$route.params.orderId}`
      }
    },
    methods: {
      ...mapActions('creator', ['getTemplates']),
    },
    async mounted() {
      const routeId = this.$route.params.id || null;
      const projects = routeId.split(',').map((project) => {
        const codes = project.split('-')
        const code = codes.filter((part, index) => index <= 1).join('-')
        return code.trim().toLowerCase()
      })
      
      const templates = await this.getTemplates();
    
      this.templates = templates.data.filter((template) => projects.includes(template.code.toLowerCase()))

      this.loading = false
    },
    components: {
      TemplateTile
    }
  }
</script>

<style lang="less" >

.templates {
  width: 100%;
  margin-top: 30px;
}

.el-main.main {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
}
</style>